import { Fragment, ReactNode, useContext, useEffect } from 'react';
import { useRouter } from 'next/router';
import {
  CurrentInferiorMenuType,
  MenuToggleContext
} from '@/base/layouts/contexts/MenuToggleContext';
import { useMediaQuery, useTheme } from '@mui/material';
import { InferiorMenuDrawer } from './InferiorMenuDrawer/InferiorMenuDrawer';
import { MainMenu } from './MainMenu/MainMenu';
import { WorkspacesMenu } from './WorkspacesMenu/WorkspacesMenu';
import { UserMenu } from './UserMenu/UserMenu';
import {
  NavigatorScreensContainer,
  NavigatorWrapper
} from './InferiorMenu.styles';

const InferiorMenu = () => {
  const theme = useTheme();
  const router = useRouter();
  const { isMenuOpen, closeMenu, goToMain, currentInferiorMenu } =
    useContext(MenuToggleContext);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const ismenuuserbox = currentInferiorMenu === 'userbox' ? 'true' : undefined;

  const currentMenu: Record<CurrentInferiorMenuType, ReactNode> = {
    menu: <MainMenu />,
    workspaces: <WorkspacesMenu />,
    userbox: <UserMenu />
  };

  useEffect(() => {
    const handleGoBack = () => {
      router.beforePopState(() => {
        closeMenu();
        return true;
      });
    };

    if (isMenuOpen) {
      handleGoBack();
    }
  }, [router, closeMenu, goToMain, isMenuOpen]);

  if (!isMobile) return null;

  return (
    <Fragment>
      <InferiorMenuDrawer isEditor={false}>
        <NavigatorWrapper ismenuuserbox={ismenuuserbox}>
          <NavigatorScreensContainer>
            {currentMenu[currentInferiorMenu]}
          </NavigatorScreensContainer>
        </NavigatorWrapper>
      </InferiorMenuDrawer>
    </Fragment>
  );
};

export default InferiorMenu;
